<template>
  <figure :class="$b()">
    <DatoCmsImage
      :class="$b('img')"
      :data="responsiveImage"
      :picture-class="$b('picture')[0]"
      :img-class="$b('image')[0]"
      :picture-style="objectPosition"
      :img-style="objectPosition"
    />
    <ArticleImageFooter
      :caption="caption"
      :credit="credit"
    />
  </figure>
</template>

<script>
import { Image as DatoCmsImage } from 'vue-datocms'

export default {
  name: 'ArticleImage',

  components: {
    DatoCmsImage
  },

  props: {
    responsiveImage: {
      type: Object,
      required: true,
    },

    focalPoint: {
      type: Object,
      required: true,
    },

    caption: {
      type: String,
      default: null,
    },

    credit: {
      type: String,
      default: null,
    },
  },

  computed: {
    objectPosition() {
      if (!this.focalPoint) return

      const xPoint = `${this.focalPoint.x * 100}%`
      const yPoint = `${this.focalPoint.y * 100}%`

      return { objectPosition: `${xPoint} ${yPoint}` }
    },
  },
}
</script>

<style lang="postcss">
.ArticleImage {
  @apply mx-0;
}

.ArticleImage__img {
  @apply mb-sm;
  max-height: 80vh;
  border-radius: 10px;
}

.ArticleImage__picture,
.ArticleImage__image {
  @apply object-cover;
}
</style>
